<template>
	<div>
		<div class="mb-3">
			<DateRangeV2
				:start.sync="duration.start"
				:end.sync="duration.end"
				@submit="loadNotes()"
				dateSelect
				:periodToShow="periodToShow"
				:persistId="tableId"
			/>
		</div>

		<LoadingSpinner v-if="table_busy" />

		<template v-else>
			<EmptyState v-if="notes.length === 0" :label="$t('notes.no_notes')" />
			
			<template v-else>
				<!-- Version mobile : cards -->
				<div class="d-md-none">
					<div 
						v-for="note in notes" 
						:key="'card-' + note.note_id"
						class="card mb-3"
					>
						<div class="card-body">
							<div class="d-flex justify-content-between align-items-start mb-2">
								<h6 class="card-title mb-0">{{ note.note_title }}</h6>
								<small class="text-muted">{{ formatDate(note.note_date) }}</small>
							</div>
							<p class="card-text text-muted mb-2" v-if="note.horse && note.horse.horse_id">
								<router-link :to="{ name: 'horseFiche', params: { horse_id: note.horse.horse_id }}">
									<font-awesome-icon :icon="['fal', 'horse']" class="mr-1" />
									{{ note.horse.horse_nom }}
								</router-link>
							</p>
							<div class="text-right">
								<a href="#" @click.prevent="downloadNote(note)" class="btn btn-sm btn-outline-primary">
									<font-awesome-icon :icon="['fas', 'download']" />
									{{ $t('action.telecharger') }}
								</a>
							</div>
						</div>
					</div>
				</div>

				<!-- Version desktop : tableau -->
				<table class="table table-hover d-none d-md-table">
					<thead>
						<tr>
							<th>{{ $t('notes.note_title') }}</th>
							<th v-if="!horse_id">{{ $t('horse.horse') }}</th>
							<th>{{ $t('notes.note_date') }}</th>
							<th class="text-center">{{ $t('action.telecharger') }}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="note in notes" :key="note.note_id">
							<td>{{ note.note_title }}</td>
							<td v-if="!horse_id">
								<router-link 
									v-if="note.horse && note.horse.horse_id" 
									:to="{ name: 'horseFiche', params: { horse_id: note.horse.horse_id }}"
								>
									{{ note.horse.horse_nom }}
								</router-link>
								<span v-else>-</span>
							</td>
							<td>{{ formatDate(note.note_date) }}</td>
							<td class="text-center">
								<a href="#" @click.prevent="downloadNote(note)">
									<font-awesome-icon :icon="['fas', 'download']" />
								</a>
							</td>
						</tr>
					</tbody>
				</table>
			</template>
		</template>

		<a ref="downloadLink" href="#" hidden></a>
	</div>
</template>

<script>
import NotesMixin from "@/mixins/Notes.js"

export default {
	name: "NoteListeCA",
	mixins: [NotesMixin],
	props: {
		horse_id: {
			type: [Number, String],
			default: null
		}
	},
	data() {
		return {
			notes: [],
			table_busy: true,
			duration: {
				start: new Date(new Date().setDate(new Date().getDate() - 30)),
				end: new Date()
			},
			periodToShow: ['personalise', 'mois', 'mois_dernier', 'annee_en_cours']
		}
	},
	computed: {
		tableId() {
			return this.horse_id ? 'horse_note_liste_ca' : 'note_liste_ca'
		}
	},
	created() {
		this.loadNotes()
	},
	methods: {
		async loadNotes() {
			this.table_busy = true
			const startDate = this.duration.start ? this.duration.start.toDateInputValue() : null
			const endDate = this.duration.end ? this.duration.end.toDateInputValue() : null

			let data
			if (this.horse_id) {
				data = await this.getHorseNotes(this.horse_id, startDate, endDate)
			} else {
				data = await this.getNotes(startDate, endDate)
			}
			// Tri par date décroissante
			this.notes = data.sort((a, b) => new Date(b.note_date) - new Date(a.note_date))
			this.table_busy = false
		},

		async downloadNote(note) {
			try {
				const content = await this.getNoteFileContent(note.note_id)
				const fileURL = window.URL.createObjectURL(new Blob([content]))
				const link = this.$refs.downloadLink

				if (content.type && content.type.includes('zip')) {
					link.setAttribute('download', 'notes.zip')
				} else if (note.files && note.files[0]) {
					link.setAttribute('download', note.files[0].files_original_name)
				} else {
					link.setAttribute('download', `${note.note_title}.pdf`)
				}

				link.href = fileURL
				link.click()
			} catch (error) {
				this.failureToast('notes.download_error')
			}
		}
	},
	components: {
		DateRangeV2: () => import('GroomyRoot/components/Inputs/DateRangeV2'),
		EmptyState: () => import('@/components/EmptyState'),
		LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35')
	}
}
</script>
